import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import Table from '../../../../../components/_table/Table/Table';
import { columns } from './columns';

const PointIssueHistoryList = (props) => {
  const { getList, pointIssueHistoryList, initialOption, pagination } = props;

  return (
    <Panel className="coupon-issue-history-list">
      <div className="panel-header">
        <div className="title">포인트 발급 이력 리스트</div>
      </div>

      <div className="panel-body">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          initialOption={initialOption}
          pagination={pagination}
          list={pointIssueHistoryList}
          size="small"
          scroll={{ x: true }}
          bordered={true}
          getList={getList}
        />
      </div>
    </Panel>
  );
};

export default PointIssueHistoryList;
